import * as buttons from 'smg/buttons';
import { CreateUser, SetPasswordOnLogin } from 'smg/customer-api/v2/users';
import { InitGoogleCredentialHandler } from 'smg/googlesignin';
import { Phone } from 'smg/phone';
import { Relref } from '../hugo';
import * as login from '../login';

main();

function main() {
    InitGoogleCredentialHandler();

    const firstName = document.querySelector('#first-name') as HTMLInputElement;
    const lastName = document.querySelector('#last-name') as HTMLInputElement;
    const company = document.querySelector('#company') as HTMLInputElement;
    const email = document.querySelector('#email') as HTMLInputElement;
    const phone = document.querySelector('#phone') as HTMLInputElement;
    const password = document.querySelector('#password') as HTMLInputElement;
    const confirmPassword = document.querySelector('#confirm-password') as HTMLInputElement;
    const matchPasswords = () => confirmPassword.setCustomValidity(confirmPassword.value === password.value ? '' : 'Passwords do not match');
    password.addEventListener('input', matchPasswords);
    confirmPassword.addEventListener('input', matchPasswords);
    const form = document.querySelector('#join-form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const confirm = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const alert = form.querySelector('.alert') as HTMLElement;
    const header = form.querySelector('h1') as HTMLElement;

    alert.parentElement?.removeChild(alert);
    alert.classList.remove('d-none');

    const showAlert = () => {
        const a = alert.cloneNode(true) as HTMLElement;
        const msg = a.querySelector('.generic');
        msg?.classList.remove('d-none');

        header.after(a);
    };

    const hideAlert = () => {
        const a = form.querySelector('.alert');
        a?.parentElement?.removeChild(a);
    };

    const p = new Phone(phone);

    form?.addEventListener('submit', async e => {
        e.preventDefault();

        hideAlert();

        fieldset.setAttribute('disabled', 'disabled');
        buttons.Start(confirm);

        const emailAddress = email.value;
        const passwordValue = password.value;
        const phoneValue = await p.format();
        CreateUser({
            'firstName': firstName.value,
            'lastName': lastName.value,
            'company': company.value,
            'emailAddress': { 'email': emailAddress },
            'phoneNumber': phoneValue !== '' ? { 'phone': phoneValue } : undefined,
        }).then(async () => {
            const prompt = SetPasswordOnLogin(await login.PromptLoginCode({ email: emailAddress }), passwordValue);

            void prompt.createCode.finally(() => {
                fieldset.removeAttribute('disabled');
                buttons.Stop(confirm);
            });

            prompt.login.
                then(() => {
                    window.location.href = Relref('/dashboard');
                }).
                catch(err => {
                    showAlert();

                    throw err;
                });
        }).catch(() => {
            fieldset.removeAttribute('disabled');
            buttons.Stop(confirm);
            showAlert();
        });
    });

    const googleBtn = document.querySelector('#google-cover-btn') as HTMLElement;

    googleBtn.addEventListener('click', () => {
        const hiddenGoogleBtn = document.querySelector('.g_id_signin') as HTMLElement;
        const googleTarget = hiddenGoogleBtn.querySelector('div[tabindex="0"]') as HTMLElement;

        googleTarget.dispatchEvent(new PointerEvent('click'));
    });
}